"use client"

import { useEffect, useState } from "react"

export const usePushSubscription = () => {
  const [subscription, setSubscription] = useState<PushSubscription | null | undefined>(undefined)

  useEffect(() => {
    if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) {
      setSubscription(null)
      return
    }
    navigator.serviceWorker.ready
      .then((reg) => reg.pushManager.getSubscription())
      .then((sub) => setSubscription(sub))
      .catch(() => setSubscription(null))
  }, [])

  return { subscription, setSubscription }
}
